var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#eaedf3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1760.256,234.988a6,6,0,1,1,6,6A6,6,0,0,1,1760.256,234.988Zm15.8,9.935a22.716,22.716,0,0,0-19.589,0,4.254,4.254,0,0,0-2.206,3.76h0a4.305,4.305,0,0,0,4.306,4.305h15.388a4.305,4.305,0,0,0,4.306-4.305h0A4.253,4.253,0,0,0,1776.051,244.923Z",
    transform: "translate(-1746.256 -220.988)",
    fill: "#002b49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.41a5c98d541677a40314b7e5feed0d57.svg";
export { ForwardRef as ReactComponent };